"use client";

// /community: the shelf of skills and guides. It keeps the root layout and wears
// the skills room's night (a deep blue-green with its light ink), the same
// ground its loading frame paints, so a hiccup never flashes the house cream.
// Retries quietly, then a button. See components/brand/NettiError.tsx.

import "../../components/community/night.css";
import { RouteError } from "../../components/brand/NettiError";
import { SKILLS_NIGHT } from "../../components/community/communityTheme";

export default function CommunityError(props: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  const ground = SKILLS_NIGHT.ground;
  return <RouteError {...props} where="community" rootClassName="cm-night" rootStyle={{ ["--bg" as string]: ground, background: ground }} />;
}
